export default "__VITE_ASSET__JbkCPzeI__"